<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
      <el-breadcrumb-item>Generation</el-breadcrumb-item>
      <el-breadcrumb-item>Phar-Based</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="content">
        The Pharmacophore-based module enables pharmacophore-guided molecular generation
        within the AIDrugDesigner platform. Pharmacophores, defined as ensembles of steric
        and electronic features required for optimal interactions with a biological target,
        provide a flexible strategy for both ligand-based and structure-based de novo design.
        In this module, users upload a pharmacophore file containing spatial and
        physicochemical feature information. The integrated PGMG model generates molecules
        conditioned on the provided pharmacophore constraints, incorporating these features
        as structural guidance during construction. The server returns chemically valid SMILES
        strings that satisfy the specified pharmacophore requirements, together with predicted
        molecular properties and interactive visualization results.
    </p>
    <!-- 表单 -->
    <phar-based-form></phar-based-form>
  </div>
</template>

<script>
import PharBasedForm from "@/components/PharBasedForm";

export default {
  name: "PharBased",
  components: {
    PharBasedForm
  }
}
</script>

<style scoped>
div {
  max-width: 1160px;
  margin: 0 auto;
}

p {
  /*padding: 20px 0 20px;*/
  line-height: 1.5em;
  text-align: left;
}

.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
